import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  position: relative;
`;

export const ButtonAddField = styled.button`
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  cursor: pointer;
  border: 1px solid #d8dae5;
  padding: 13px;
`;

export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;
export { Block } from '@components/Filters/FilterUpdates/Menu.styles';
